import { addDuration, diffInUnits, startOf } from '@lingoda/dates';

export type LeadTime = {
    leadTimeInDays: number;
    firstDateBeyondLeadTime: Date;
};

// Counted from midnight rather than from the current moment, so the day count and the date do
// not shift as the clock ticks, and a clock change cannot add or drop a day.
// Named to avoid colliding with the getLeadTime redux action @lingoda/booking exports.
export const resolveLeadTime = (now: Date, duration: string | undefined): LeadTime | undefined => {
    const today = startOf('day', now);
    const firstDateBeyondLeadTime = addLeadTime(today, duration);

    if (!firstDateBeyondLeadTime) {
        return undefined;
    }

    const leadTimeInDays = diffInUnits('days', firstDateBeyondLeadTime, today);

    return leadTimeInDays > 0 ? { leadTimeInDays, firstDateBeyondLeadTime } : undefined;
};

// addDuration throws on anything that is not an ISO duration, and a bad value must hide the
// banner rather than break the page.
const addLeadTime = (today: Date, duration: string | undefined): Date | undefined => {
    if (!duration) {
        return undefined;
    }

    try {
        return addDuration(today, duration);
    } catch {
        return undefined;
    }
};
